import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectUserLoggedIn } from 'modules/login/slice/loginSlice';
import { saveCurrentPathForLoginRedirect } from 'services/loginRedirect';
import SessionActivityProvider from '../components/SessionActivityProvider';
import { ModalStackProvider } from 'components/ModalStack';

const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectUserLoggedIn);
  const location = useLocation();

  if (!isLoggedIn) {
    saveCurrentPathForLoginRedirect();
    return <Navigate to="/login" state={{ from: location }} />;
  }
  return (
    <SessionActivityProvider>
      <ModalStackProvider>{children}</ModalStackProvider>
    </SessionActivityProvider>
  );
};

export default PrivateRoute;
